import {
  MainContentArea,
  PageContentWrapper,
  PageTitle,
} from "melco-ui";
import { DisplayStatistics } from "../../components/reporting/statistics/DisplayStatistics";

export const Statistics: React.FC = () => {
  return (
    <MainContentArea contentPadding>
      <PageContentWrapper>
        <PageTitle>Reporting</PageTitle>
        {/* <FullWidthSpace
          direction="vertical"
          size="small"
          data-cy-id="dashboard-statistics"
        > */}
        <DisplayStatistics />
        {/* </FullWidthSpace> */}
      </PageContentWrapper>
    </MainContentArea>
  );
};
